// 导出配置的路由器
export default [{
  path: '/possessionCenter',
  component: () => import('@/layout/index'),
  redirect: 'possessionCenter/orderManager',
  meta: {title: '财务中心', icon: 'icon-shouru2', perms: ['bee:possession']},
  children: [
    {
      path: 'incomeView',
      component: () => import('@/module/possessionCenter/page/incomeView.vue'),
      meta: {title: '收入总览(总监控版)', icon: 'icon-zhangdan', perms: ['bee:order:screenAll']}
    },
    {
      path: 'operatorIncomeView',
      component: () => import('@/module/possessionCenter/page/operatorIncomeView.vue'),
      meta: {title: '收入总览(运营商版)', icon: 'icon-zhangdan', perms: ['bee:order:screenOperator']}
    },
    {
      path: 'orderManager',
      component: () => import('@/module/possessionCenter/page/order/manage.vue'),
      meta: {title: '订单管理', icon: 'icon-order', perms: ['bee:possession:order']}
    },
    {
      path: 'settleManager',
      component: () => import('@/module/possessionCenter/page/settle/manage.vue'),
      meta: {title: '结算单管理', icon: 'icon-zhangdan', perms: ['bee:possession:settle']}
    },
    {
      path: 'groupBill',
      component: () => import('@/module/possessionCenter/page/groupBill/manage.vue'),
      meta: {title: '集团账单', icon: 'icon-jituan2', perms: ['bee:possession:groupOrder']}
    },
    {
      path: 'interactiveOrder',
      component: () => import('@/module/possessionCenter/page/cecOrder/manage.vue'),
      meta: {title: '互联互通订单', icon: 'icon-zhangdan1', perms: ['bee:possession:cecOrder']}
    },
    {
      path: 'invoiceManager',
      component: () => import('@/module/possessionCenter/page/invoiceManager.vue'),
      meta: {title: '发票管理', icon: 'icon-fapiao1', perms: ['bee:order:invoice']}
    },

    {
      path: 'billManager',
      component: () => import('@/module/possessionCenter/page/statement/billManager.vue'),
      meta: {title: '对账单管理', icon: 'icon-zhangdan',perms: ['bee:order:bill']}
    }
    ,
    // {
    //   path: 'simRenewManager',
    //   component: () => import('@/module/possessionCenter/page/simRenewManager.vue'),
    //   meta: {title: 'sim卡支付管理', icon: 'icon-fapiao1', perms: ['bee:order:invoice']}
    // }
  ]
}]



// WEBPACK FOOTER //
// ./src/module/possessionCenter/router/index.js